import { EFeatures } from '@constants';

import {
  ChatWidget,
  ContactWidget,
  DeliverablesWidget,
  PostWidget,
  QuizModeWidget,
  TasksWidget,
  LiveClassesWidget,
  ExamGroupsRankingWidget,
  SubscriptionsWidget,
  ProgressWidget
} from '../components/Widgets';

import { WidgetProps } from '@/types';

type WidgetConfig = {
  Widget: React.FC<WidgetProps>;
  availableForFeature?: EFeatures;
};

export const STUDENT_WIDGETS: {
  leftColumn: WidgetConfig[];
  rightColumn: WidgetConfig[];
} = {
  leftColumn: [
    {
      Widget: ChatWidget,
      availableForFeature: EFeatures.TUTORING
    },
    {
      Widget: TasksWidget,
      availableForFeature: EFeatures.PLANIFICATION
    },
    {
      Widget: SubscriptionsWidget,
      availableForFeature: EFeatures.CONTENT
    },
    {
      Widget: LiveClassesWidget,
      availableForFeature: EFeatures.LIVE_CLASSES
    },
    {
      Widget: DeliverablesWidget,
      availableForFeature: EFeatures.EXAMS_SCORES
    },
    {
      Widget: QuizModeWidget,
      availableForFeature: EFeatures.QUIZZES
    },
    {
      Widget: ExamGroupsRankingWidget
    }
  ],
  rightColumn: [
    {
      Widget: ProgressWidget
    },
    {
      Widget: PostWidget
    },

    {
      Widget: ContactWidget
    }
  ]
};
